export const DEFAULT_COOKIES_NAME = 'RavnurToken';

export const FORM_CTX_PROVIDER_KEY = 'FORM_CONTEXT';

export const STORAGE_GROUP = '_s_';
export const STORAGE_TOKEN_KEY = 'RAT';
export const STORAGE_COOKIE_KEY = 'CN';
